import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type CampaignFormValues = {
  campaignAmount: number;
  campaignDuration: number;
  campaignLink: string;
  campaignName: string;
  campaignPriority: number;
  campaignResource: File;
  campaignStartDate: Date;
  campaignType: string;
  company: string;
};

export const campaignValidationSchema = yup.object({
  campaignAmount: yup
    .number()
    .required('Le montant est obligatoire.')
    .positive('Le montant doit être un nombre positif.')
    .typeError('Veuillez entrer un montant valide.'),
  campaignDuration: yup
    .number()
    .required('La durée est obligatoire.')
    .positive('La durée est obligatoire.')
    .integer('La durée doit être un entier.')
    .typeError('Veuillez entrer une durée valide.'),
  campaignLink: yup
    .string()
    .required('Le lien est obligatoire.')
    .test('is-valid-url', 'Veuillez entrer un lien valide.', (value) => {
      if (!value) return false;
      const urlRegex =
        /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;
      return urlRegex.test(value);
    }),
  campaignName: yup
    .string()
    .required('Le nom est obligatoire.')
    .min(3, 'Le nom doit contenir au moins 3 caractères.')
    .max(100, 'Le nom ne peut pas dépasser 100 caractères.'),
  campaignPriority: yup
    .number()
    .required()
    .min(1, 'La priorité est obligatoire.')
    .typeError('Veuillez entrer une priorité valide.'),
  campaignResource: yup
    .mixed<File>()
    .required('Le fichier est obligatoire.')
    .test(
      'fileType',
      'Seuls les fichiers PNG, JPEG, JPG et MP3 sont autorisés.',
      (value) => {
        if (!value) return false;
        return ['image/jpeg', 'image/png', 'image/jpg', 'audio/mpeg'].includes(
          value.type,
        );
      },
    ),
  campaignStartDate: yup
    .date()
    .required('La date est obligatoire.')
    .typeError('Veuillez entrer une date valide.'),
  campaignType: yup.string().required('Le type est obligatoire.'),
  company: yup.string().required('Le nom est obligatoire.'),
});

export const useCampaignForm = () => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<CampaignFormValues>(campaignValidationSchema);

  return { register, handleSubmit, errors, setValue, reset };
};
